import { Injectable } from '@angular/core';


export interface TokenData {
  idAzienda: string;
  idAnagrafica: string;
  email?: string;
  exp?: number;
  iat?: number;
  [key: string]: any;
}


@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private TOKEN_KEY = 'access_token';

  saveToken(token: string): void {
    localStorage.setItem(this.TOKEN_KEY, token);
  }

  getToken(): string | null {
    return localStorage.getItem(this.TOKEN_KEY);
  }

  isLoggedIn(): boolean {
    return !!this.getToken();
  }

  logout(): void {
    localStorage.removeItem(this.TOKEN_KEY);
  }

  saveUser(user: any): void {
    localStorage.setItem('user', JSON.stringify(user));
  }

  getUser(): any {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  }

  /**
   * Decodifica il token JWT e restituisce i dati
   * @returns TokenData con idAzienda, idAnagrafica e altri campi
   */
  getDecodedToken(): TokenData | null {
    const token = this.getToken();
    
    if (!token) {
      return null;
    }

    try {
      // Decodifica il payload del JWT (parte centrale)
      const payload = token.split('.')[1];
      const decodedPayload = atob(payload);
      return JSON.parse(decodedPayload) as TokenData;
    } catch (error) {
      console.error('Errore nella decodifica del token:', error);
      return null;
    }
  }
}
